import { useLocalePath } from '#imports';

export default defineNuxtRouteMiddleware((to, from) => {
    if (!to.name) {
        return;
    }
    const [routeName, lang] = to.name.split('___');

    if (routeName === 'locale-slug' || lang !== 'ru' || to.matched.length === 0) {
        return;
    }

    const localePath = useLocalePath();

    return navigateTo(localePath({name: routeName}, 'pl'), { redirectCode: 301});
});
